import { Component } from '@theme/component';

class KqInformationPage extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.initializeFilters();
  }

  updatedCallback() {
    super.updatedCallback();
    this.initializeFilters();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.filterController?.abort();
  }

  initializeFilters() {
    this.filterController?.abort();
    this.filterController = new AbortController();
    const toolbar = this.querySelector('[data-toolbar]');
    if (!toolbar) return;
    const cards = [...this.querySelectorAll('[data-filter-card]')];
    const query = this.querySelector('[data-query]');
    const category = this.querySelector('[data-category]');
    const type = this.querySelector('[data-type]');
    const status = this.querySelector('[data-status]');
    const count = this.querySelector('[data-count]');
    const empty = this.querySelector('[data-empty]');
    if (!query || !category || !count || !status || !empty) return;
    const populate = (select, key) => {
      const previous = select.value;
      while (select.options.length > 1) select.remove(1);
      const values = [...new Set(cards.map(card => card.dataset[key]).filter(Boolean))].sort((a,b) => a.localeCompare(b));
      for (const value of values) select.add(new Option(value, value));
      if (values.includes(previous)) select.value = previous;
    };
    populate(category, 'category');
    if (type) populate(type, 'type');
    const filter = () => {
      const term = query.value.trim().toLocaleLowerCase();
      let visible = 0;
      for (const card of cards) {
        const match = (!term || card.textContent.toLocaleLowerCase().includes(term)) && (!category.value || card.dataset.category === category.value) && (!type?.value || card.dataset.type === type.value);
        card.hidden = !match;
        if (match) visible++;
      }
      count.textContent = String(visible);
      empty.hidden = visible > 0;
    };
    const options = { signal: this.filterController.signal };
    query.addEventListener('input', filter, options);
    category.addEventListener('change', filter, options);
    type?.addEventListener('change', filter, options);
    this.querySelector('[data-reset]')?.addEventListener('click', () => {
      query.value = '';
      category.value = '';
      if (type) type.value = '';
      filter();
      query.focus();
    }, options);
    toolbar.hidden = false;
    status.hidden = false;
    filter();
  }
}

if (!customElements.get('kq-information-page')) customElements.define('kq-information-page', KqInformationPage);
